import palette from '@lib/core/src/theme/palette';
import { styled, Autocomplete, Typography } from '@mui/material';

export const Container = styled(Autocomplete)({
  '& .MuiFormControl-root': {
    height: '40px'
  },
  '& .MuiAutocomplete-inputRoot': {
    height: '40px'
  },
  '& .MuiInputBase-root': {
    padding: '0px'
  }
});

export const Row = styled('li')({
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  height: '48px',
  padding: '0px 10px',
  alignItems: 'center',
  width: '100%',
  justifyContent: 'flex-start',
  gap: '12px',
  borderBottom: `1px solid ${palette.grey[200]}`,
  '&.MuiAutocomplete-option[aria-selected="true"]': {
    backgroundColor: 'unset'
  },
  '&.MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ${palette.white}`
  },
  '&.MuiAutocomplete-option.Mui-focused': {
    background: `linear-gradient(0deg, rgba(0, 0, 0, 0.02) 0%, rgba(0, 0, 0, 0.02) 100%), ${palette.white}`
  }
});

export const Text = styled(Typography)({
  fontSize: '12px',
  fontWeight: '500',
  color: palette.grey[500],
  lineHeight: '16px'
});
